import { render, staticRenderFns } from "./EditTenantConfig.vue?vue&type=template&id=94d271f4"
import script from "./EditTenantConfig.vue?vue&type=script&lang=js"
export * from "./EditTenantConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports